import { Field } from '@components/gassan-ui'
import { useMeQuery } from '@generated'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

export const BasicFields: FC = () => {
  const { t } = useTranslation('forms')
  const [meQuery] = useMeQuery()

  return (
    <>
      <Field
        name="firstName"
        label={t('labels.firstName')}
        field="input"
        gridColumn="span 12"
        autoComplete="given-name"
      />
      <Field
        name="lastName"
        label={t('labels.lastName')}
        field="input"
        gridColumn="span 12"
        autoComplete="family-name"
      />
      <Field
        name="email"
        label={t('labels.email')}
        field="input"
        gridColumn="span 12"
        autoComplete="email"
        disabled={!!meQuery.data?.me?.email}
      />
    </>
  )
}
